import { TiptapEditorHTMLView, getText } from '@amzn/awscat-editor';
import { Icon } from '@amzn/awsui-components-core';
import { ContentNode } from '@amzn/awscat-pattern-library-service-model';
import React, { useEffect, useState } from 'react';
import '../../../resources/styles/scss/components/ContentPageTree.css';
import { findNodeById } from '../../../api/ContentUtil';
import { TreeStatus } from './ContentPagesTree';

interface ContentPageTreeSectionProps {
  nodeClassName: string;
  selectedNodeClassName: string;
  node: ContentNode;
  selectedNode?: ContentNode;
  onNodeSelected?: (id: ContentNode, depth: number) => void;
  treeStatus?: TreeStatus;
  depth: number;
}

export const ContentPageTreeSection = (props: ContentPageTreeSectionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [treeStatus, setTreeStatus] = useState(props.treeStatus);

  useEffect(() => {
    setTreeStatus(props.treeStatus);

    if (props.treeStatus === TreeStatus.CollapseAll) {
      setIsExpanded(false);
    }

    if (props.treeStatus === TreeStatus.ExpandAll) {
      setIsExpanded(true);
    }
  }, [props.treeStatus]);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const selectNode = () => {
    if (props.onNodeSelected) {
      props.onNodeSelected(props.node, props.depth);
    }
  };

  const childNodes = props.node.subContent.map((n) => {
    return (
      <ContentPageTreeSection
        key={n.href || n.id}
        node={n}
        selectedNode={props.selectedNode}
        nodeClassName={props.nodeClassName}
        selectedNodeClassName={props.selectedNodeClassName}
        onNodeSelected={props.onNodeSelected}
        treeStatus={treeStatus}
        depth={props.depth + 1}
      />
    );
  });

  const caretIcon = isExpanded ? 'caret-down-filled' : 'caret-right-filled';

  const icon =
    props.node.subContent.length > 0 ? (
      <span className="expand-icon" onClick={toggleExpanded}>
        <Icon name={caretIcon} />
      </span>
    ) : null;

  const titleClassName =
    props.node.id === props.selectedNode?.id ? props.selectedNodeClassName : props.nodeClassName;

  // Open tree if its children node is currently selected.
  // @ts-expect-error TS2345 - strict migration
  const isChildNodeSelected = !!findNodeById(props.selectedNode?.id, props.node?.subContent);
  const titleText =
    typeof props.node.title === 'string' ? props.node.title : getText(props.node.title);
  const shortTitleText = props.node.shortTitle
    ? typeof props.node.shortTitle === 'string'
      ? props.node.shortTitle
      : getText(props.node.shortTitle)
    : '';
  const displayText = shortTitleText || titleText;
  const title = <TiptapEditorHTMLView model={displayText} />;
  return (
    <div className="tree-section">
      <div className={`${titleClassName} display-flex-row`} lang="en">
        {icon}
        <span className="page-title" onClick={selectNode}>
          {title}
        </span>
      </div>
      <div className="child-nodes">{isExpanded || isChildNodeSelected ? childNodes : null}</div>
    </div>
  );
};
